import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import getCampaignColumn from './CampaignGridColumnConfig';
import SupplierAnalytics from '../SupplierAnalytics';
import LoadingWrapper from '../../Shared/LoadingWrapper';
import readXlsxFile from 'read-excel-file';
import APIService from '../../../Services/APIService';

export default function CampaignAnalytics() {
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [supplierData, setSupplierData] = useState({});
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [typeOfCampaign, setTypeOfCampaign] = useState('');
  const [token, setToken] = useState('');

  const fileUpload = (e) => {
    var fileSelect = e.target.files[0];

    readXlsxFile(fileSelect).then((rows) => {
      let fileData = [];
      if (rows && rows.length > 1) {
        let header = rows[0];
        for (var i = 1; i < rows.length; i++) {
          var obj = {};
          var currentline = rows[i];
          for (var j = 0; j < header.length; j++) {
            obj[header[j]] = currentline[j];
          }
          fileData.push(obj);
        }
      }
      fetchAreaData(fileData);
    });
  };

  const fetchAreaData = async (fileData) => {
    try {
      let res = await APIService.post(`v0/ui/bulk-locations/`, fileData);
      if (res.status == 200) {
        setSupplierData(res?.data);
      }
    } catch (error) {
      return error;
    }
  };

  const expandComponent = () => {
    return (
      <SupplierAnalytics supplierData={supplierData} token={token} campaignType={typeOfCampaign} />
    );
  };

  const getSupplierCampaignDetails = async (campaignId, typeOfCampaign) => {
    setSelectedCampaign(campaignId);
    setTypeOfCampaign(typeOfCampaign);
    let res = await APIService.get(`v0/ui/ops/campaign/supplier-count/?campaign_id=${campaignId}`);
    if (res.status == 200) setSupplierData(res?.data);
  };

  const getCampaignData = async () => {
    let res = await APIService.get(`v0/ui/ops/campaign-analytics/`);
    if (res.status == 200) setCampaignList(res?.data);
    setIsDataFetched(true);
  };

  useEffect(() => {
    getCampaignData();
  }, []);

  const isExpandableRow = {
    renderer: (row) => {
      return (
        <SupplierAnalytics campaignId={row.campaign_id} campaignType={row.type_of_end_customer} />
      );
    },
    showExpandColumn: true,
    expandByColumnOnly: true,
  };

  return (
    <div className="expand-icon-padding">
      {/* <div className="page-title-header">
        <div className="page-title-action-left">
          <div className="upload-wrapper">
            <label for="upload_file">Upload Area/Subarea Excel </label>
            <div class="input_container">
              <input type="file" id="upload_file" onChange={(e) => fileUpload(e)} />
            </div>
          </div>
        </div>
        <div className="page-title-center"></div>
        <div className="page-title-header-right">
          <a className="btn btn-primary" href="/sample_files/area_subarea.xlsx" download>
            Download demo{' '}
          </a>
        </div>
      </div> */}
      <div className="page-title-header">
        <div className="page-title-action-left">
          <div className="back-btn-wrapper">
            {/* <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>
                navigate(`/r/operations-dashboard/city/${supplier_type}`, {
                  state: { supplier_type: supplier_type, name: supplier_type },
                })
              }
            >
              {' '}
              ←{' '}
            </button> */}
          </div>
          <h4></h4>
        </div>
        {/* <div className="page-title-header-right">
          <div className="upload-wrapper">
            <label for="upload_file">Upload Area/Subarea Excel </label>
            <div className="input_container">
              <input type="file" id="upload_file" onChange={(e) => fileUpload(e)} />
            </div>
          </div>
          <div>
            <a className="btn btn-primary" href="/sample_files/area_subarea.xlsx" download>
              Download demo{' '}
            </a>
          </div>
        </div> */}
        <div className="container mt-4">
          <div className='col-12 row justify-content-center'>
          <div className="card col-5">
            <div className="card-body">
              <div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
                {/* Upload Input */}
                <div className="me-3">
                  <label
                    htmlFor="upload_file"
                    className="form-label fw-bold h5 d-block text-center mb-3"
                  >
                    Upload Area/Subarea Excel
                  </label>
                  <input
                    type="file"
                    className="form-control-file"
                    id="upload_file"
                    onChange={fileUpload}
                  />
                </div>

                {/* Download Button */}
                <div>
                  <label className="d-block invisible">Placeholder</label>{' '}
                  {/* Keeps vertical alignment */}
                  <a className="btn btn-primary" href="/sample_files/area_subarea.xlsx" download>
                    Download Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      {isDataFetched ? (
        <LoadingWrapper />
      ) : (
        <>
          {campaignList?.length > 0 ? (
            <BootstrapTable
              keyField="campaign_id"
              responsive
              data={campaignList}
              columns={getCampaignColumn()}
              exportCsv={false}
              // search={true}
              // pagination={true}
              // expandableRow={isExpandableRow}
              expandRow={isExpandableRow}
              // expandComponent={expandComponent}
              // hover={true}
              // multiColumnSearch={true}
              // exportCSV={false}
              // options={options}
              // expandColumnOptions={{
              //   expandColumnVisible: isExpandableRow,
              //   expandColumnComponent: expandColumnComponent,
              //   columnWidth: 50,
              // }}
              // headerStyle={{ backgroundColor: '#707f8c9e' }}
              // trStyle={{ cursor: 'pointer' }}
              // tableStyle={{ marginBottom: '0px' }}
            />
          ) : (
            <div className="alert alert-info" role="alert" style={{ marginTop: '2em' }}>
              No Records Found !
            </div>
          )}
        </>
      )}
    </div>
  );
}
